import script from "./404.vue?vue&type=script&setup=true&lang=js"
export * from "./404.vue?vue&type=script&setup=true&lang=js"

import "./404.vue?vue&type=style&index=0&id=9b601e5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b601e5a"]])

export default __exports__